import classNames from "classnames";
import Icon from "../Icon";

export const MobileExpandActionButton = ({ isExpanded, onClick }: { isExpanded?: boolean; onClick: () => void }) => {
  return (
    <div
      className={classNames(
        "flex items-center justify-center rounded-full transition-colors hover:bg-sys-brand-secondary-container w-10 h-10 p-0",
        {
          "rounded-full bg-sys-brand-secondary-container": isExpanded,
          "bg-transparent": !isExpanded
        }
      )}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      data-testid="mobile-expand-action-button"
      role="button"
    >
      <Icon name={isExpanded ? "unfold_less" : "unfold_more"} size={24} />
    </div>
  );
};
